/**
 * Mobile-web SPA host: no `chrome.runtime`. Let webpack discover, bundle and
 * fingerprint the scan worker via the static `new Worker(new URL(..., import.meta.url))`
 * form (the same pattern mainController.worker / railgun.worker already use on
 * mobile-web). `config.output.publicPath = '/'` makes the worker's split chunks
 * resolve from the site root; CSP `worker-src 'self'` permits the same-origin worker.
 *
 * This file is NEVER imported directly — webpack swaps `spawnScanWorker.ts` for it
 * in the isMobileWebapp build via `config.resolve.alias`, so the extension build
 * never compiles this `new URL` (which would otherwise emit a second, unused copy
 * of the worker under chunks/).
 */
export function spawnScanWorker(chainId: number): Worker {
  return new Worker(new URL('./railgunScanWorker.worker.ts', import.meta.url), {
    name: `railgun-scan-${chainId}`
  })
}
